(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[15908,2610,40659,81066,75847,44709,40852,81243,74453,44954,40617],{

/***/ 32924:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({ value: true });

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var blocks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS = void 0;
/**
 * Map of all Contentful block types. Blocks contain inline or block nodes.
 */
var BLOCKS;
(function (BLOCKS) {
    BLOCKS["DOCUMENT"] = "document";
    BLOCKS["PARAGRAPH"] = "paragraph";
    BLOCKS["HEADING_1"] = "heading-1";
    BLOCKS["HEADING_2"] = "heading-2";
    BLOCKS["HEADING_3"] = "heading-3";
    BLOCKS["HEADING_4"] = "heading-4";
    BLOCKS["HEADING_5"] = "heading-5";
    BLOCKS["HEADING_6"] = "heading-6";
    BLOCKS["OL_LIST"] = "ordered-list";
    BLOCKS["UL_LIST"] = "unordered-list";
    BLOCKS["LIST_ITEM"] = "list-item";
    BLOCKS["HR"] = "hr";
    BLOCKS["QUOTE"] = "blockquote";
    BLOCKS["EMBEDDED_ENTRY"] = "embedded-entry-block";
    BLOCKS["EMBEDDED_ASSET"] = "embedded-asset-block";
    BLOCKS["TABLE"] = "table";
    BLOCKS["TABLE_ROW"] = "table-row";
    BLOCKS["TABLE_CELL"] = "table-cell";
    BLOCKS["TABLE_HEADER_CELL"] = "table-header-cell";
})(BLOCKS = exports.BLOCKS || (exports.BLOCKS = {}));

});

unwrapExports(blocks);
var blocks_1 = blocks.BLOCKS;

var inlines = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.INLINES = void 0;
/**
 * Map of all Contentful inline types. Inline contain inline or text nodes.
 */
var INLINES;
(function (INLINES) {
    INLINES["HYPERLINK"] = "hyperlink";
    INLINES["ENTRY_HYPERLINK"] = "entry-hyperlink";
    INLINES["ASSET_HYPERLINK"] = "asset-hyperlink";
    INLINES["EMBEDDED_ENTRY"] = "embedded-entry-inline";
})(INLINES = exports.INLINES || (exports.INLINES = {}));

});

unwrapExports(inlines);
var inlines_1 = inlines.INLINES;

var marks = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Map of all Contentful marks.
 */
var MARKS;
(function (MARKS) {
    MARKS["BOLD"] = "bold";
    MARKS["ITALIC"] = "italic";
    MARKS["UNDERLINE"] = "underline";
    MARKS["CODE"] = "code";
    MARKS["SUPERSCRIPT"] = "superscript";
    MARKS["SUBSCRIPT"] = "subscript";
})(MARKS || (MARKS = {}));
exports.default = MARKS;

});

unwrapExports(marks);

var schemaConstraints = createCommonjsModule(function (module, exports) {
var __spreadArray = (commonjsGlobal && commonjsGlobal.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.V1_MARKS = exports.V1_NODE_TYPES = exports.TEXT_CONTAINERS = exports.HEADINGS = exports.CONTAINERS = exports.VOID_BLOCKS = exports.TABLE_BLOCKS = exports.LIST_ITEM_BLOCKS = exports.TOP_LEVEL_BLOCKS = void 0;


var marks_1 = __importDefault(marks);
/**
 * Array of all top level block types.
 * Only these block types can be the direct children of the document.
 */
exports.TOP_LEVEL_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    blocks.BLOCKS.TABLE,
];
/**
 * Array of all allowed block types inside list items
 */
exports.LIST_ITEM_BLOCKS = [
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
];
exports.TABLE_BLOCKS = [
    blocks.BLOCKS.TABLE,
    blocks.BLOCKS.TABLE_ROW,
    blocks.BLOCKS.TABLE_CELL,
    blocks.BLOCKS.TABLE_HEADER_CELL,
];
/**
 * Array of all void block types
 */
exports.VOID_BLOCKS = [blocks.BLOCKS.HR, blocks.BLOCKS.EMBEDDED_ENTRY, blocks.BLOCKS.EMBEDDED_ASSET];
/**
 * Dictionary of all container block types, and the set block types they accept as children.
 *
 * Note: This does not include `[BLOCKS.DOCUMENT]: TOP_LEVEL_BLOCKS`
 */
exports.CONTAINERS = (_a = {},
    _a[blocks.BLOCKS.OL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.UL_LIST] = [blocks.BLOCKS.LIST_ITEM],
    _a[blocks.BLOCKS.LIST_ITEM] = exports.LIST_ITEM_BLOCKS,
    _a[blocks.BLOCKS.QUOTE] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE] = [blocks.BLOCKS.TABLE_ROW],
    _a[blocks.BLOCKS.TABLE_ROW] = [blocks.BLOCKS.TABLE_CELL, blocks.BLOCKS.TABLE_HEADER_CELL],
    _a[blocks.BLOCKS.TABLE_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a[blocks.BLOCKS.TABLE_HEADER_CELL] = [blocks.BLOCKS.PARAGRAPH],
    _a);
/**
 * Array of all heading levels
 */
exports.HEADINGS = [
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
];
/**
 * Array of all block types that may contain text and inline nodes.
 */
exports.TEXT_CONTAINERS = __spreadArray([blocks.BLOCKS.PARAGRAPH], exports.HEADINGS, true);
/**
 * Node types before `tables` release.
 */
exports.V1_NODE_TYPES = [
    blocks.BLOCKS.DOCUMENT,
    blocks.BLOCKS.PARAGRAPH,
    blocks.BLOCKS.HEADING_1,
    blocks.BLOCKS.HEADING_2,
    blocks.BLOCKS.HEADING_3,
    blocks.BLOCKS.HEADING_4,
    blocks.BLOCKS.HEADING_5,
    blocks.BLOCKS.HEADING_6,
    blocks.BLOCKS.OL_LIST,
    blocks.BLOCKS.UL_LIST,
    blocks.BLOCKS.LIST_ITEM,
    blocks.BLOCKS.HR,
    blocks.BLOCKS.QUOTE,
    blocks.BLOCKS.EMBEDDED_ENTRY,
    blocks.BLOCKS.EMBEDDED_ASSET,
    inlines.INLINES.HYPERLINK,
    inlines.INLINES.ENTRY_HYPERLINK,
    inlines.INLINES.ASSET_HYPERLINK,
    inlines.INLINES.EMBEDDED_ENTRY,
    'text',
];
/**
 * Marks before `superscript` & `subscript` release.
 */
exports.V1_MARKS = [marks_1.default.BOLD, marks_1.default.CODE, marks_1.default.ITALIC, marks_1.default.UNDERLINE];

});

unwrapExports(schemaConstraints);
var schemaConstraints_1 = schemaConstraints.V1_MARKS;
var schemaConstraints_2 = schemaConstraints.V1_NODE_TYPES;
var schemaConstraints_3 = schemaConstraints.TEXT_CONTAINERS;
var schemaConstraints_4 = schemaConstraints.HEADINGS;
var schemaConstraints_5 = schemaConstraints.CONTAINERS;
var schemaConstraints_6 = schemaConstraints.VOID_BLOCKS;
var schemaConstraints_7 = schemaConstraints.TABLE_BLOCKS;
var schemaConstraints_8 = schemaConstraints.LIST_ITEM_BLOCKS;
var schemaConstraints_9 = schemaConstraints.TOP_LEVEL_BLOCKS;

var types = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(types);

var nodeTypes = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

});

unwrapExports(nodeTypes);

var emptyDocument = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });

/**
 * A rich text document considered to be empty.
 * Any other document structure than this is not considered empty.
 */
var EMPTY_DOCUMENT = {
    nodeType: blocks.BLOCKS.DOCUMENT,
    data: {},
    content: [
        {
            nodeType: blocks.BLOCKS.PARAGRAPH,
            data: {},
            content: [
                {
                    nodeType: 'text',
                    value: '',
                    marks: [],
                    data: {},
                },
            ],
        },
    ],
};
exports.default = EMPTY_DOCUMENT;

});

unwrapExports(emptyDocument);

var helpers = createCommonjsModule(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isText = exports.isBlock = exports.isInline = void 0;


/**
 * Tiny replacement for Object.values(object).includes(key) to
 * avoid including CoreJS polyfills
 */
function hasValue(obj, value) {
    for (var _i = 0, _a = Object.keys(obj); _i < _a.length; _i++) {
        var key = _a[_i];
        if (value === obj[key]) {
            return true;
        }
    }
    return false;
}
/**
 * Checks if the node is an instance of Inline.
 */
function isInline(node) {
    return hasValue(inlines.INLINES, node.nodeType);
}
exports.isInline = isInline;
/**
 * Checks if the node is an instance of Block.
 */
function isBlock(node) {
    return hasValue(blocks.BLOCKS, node.nodeType);
}
exports.isBlock = isBlock;
/**
 * Checks if the node is an instance of Text.
 */
function isText(node) {
    return node.nodeType === 'text';
}
exports.isText = isText;

});

unwrapExports(helpers);
var helpers_1 = helpers.isText;
var helpers_2 = helpers.isBlock;
var helpers_3 = helpers.isInline;

var dist = createCommonjsModule(function (module, exports) {
var __createBinding = (commonjsGlobal && commonjsGlobal.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (commonjsGlobal && commonjsGlobal.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __exportStar = (commonjsGlobal && commonjsGlobal.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importStar = (commonjsGlobal && commonjsGlobal.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (commonjsGlobal && commonjsGlobal.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.helpers = exports.EMPTY_DOCUMENT = exports.MARKS = exports.INLINES = exports.BLOCKS = void 0;

Object.defineProperty(exports, "BLOCKS", { enumerable: true, get: function () { return blocks.BLOCKS; } });

Object.defineProperty(exports, "INLINES", { enumerable: true, get: function () { return inlines.INLINES; } });

Object.defineProperty(exports, "MARKS", { enumerable: true, get: function () { return __importDefault(marks).default; } });
__exportStar(schemaConstraints, exports);
__exportStar(types, exports);
__exportStar(nodeTypes, exports);

Object.defineProperty(exports, "EMPTY_DOCUMENT", { enumerable: true, get: function () { return __importDefault(emptyDocument).default; } });
var helpers$1 = __importStar(helpers);
exports.helpers = helpers$1;

});

unwrapExports(dist);
var dist_1 = dist.helpers;
var dist_2 = dist.EMPTY_DOCUMENT;
var dist_3 = dist.MARKS;
var dist_4 = dist.INLINES;
var dist_5 = dist.BLOCKS;

/**
 * Returns the text value of a rich text document.
 *
 * NB: This can be applied to non text node of a structured text document,
 * hence the flexible typing.
 */
function documentToPlainTextString(rootNode, blockDivisor) {
    if (blockDivisor === void 0) { blockDivisor = ' '; }
    if (!rootNode || !rootNode.content) {
        /**
         * Handles edge cases, such as when the value is not set in the CMA or the
         * field has not been properly validated, e.g. because of a user extension.
         * Note that we are nevertheless strictly type-casting `rootNode` as
         * Block | Inline. Valid rich text documents (and their branch block nodes)
         * should never lack a Node[] `content` property.
         */
        return '';
    }
    /**
     * Algorithm notes: We only want to apply spacing when a node is part of a
     * sequence. This is tricky because nodes can often be deeply nested within
     * non-semantic content arrays. For example, to get the text value of an
     * unordered list, we have to traverse like so:
     *
     * {
     *   nodeType: BLOCKS.UL_LIST,
     *   data: {},
     *   content: [
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'List ', marks: [] },
     *           { nodeType: 'text', data: {}, value: 'item', marks: [{ type: 'bold' }] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data: {},
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.HR,
     *         data: {},
     *         content: [],
     *       }]
     *     },
     *     {
     *       nodeType: BLOCKS.LIST_ITEM,
     *       data: {},
     *       content: [{
     *         nodeType: BLOCKS.PARAGRAPH,
     *         data:
     *         content: [
     *           { nodeType: 'text', data: {}, value: 'Yet another list item', marks: [] }
     *         ]
     *       }]
     *     },
     *   }]
     * }
     *
     * We want there to be a space between 'List item' and 'Another list item' (to
     * denote a visual line break, which conventionally appears between non-text
     * node sequences) but not a redundant space between 'List ' and 'item'.
     * Moreover, we want just a _singular_ space between 'Another list item' and
     * 'Yet another list item' - the non-semantic HR between the two nodes should
     * not denote an additional space.
     */
    return rootNode.content.reduce(function (acc, node, i) {
        var nodeTextValue;
        if (dist_1.isText(node)) {
            nodeTextValue = node.value;
        }
        else if (dist_1.isBlock(node) || dist_1.isInline(node)) {
            nodeTextValue = documentToPlainTextString(node, blockDivisor);
            if (!nodeTextValue.length) {
                return acc;
            }
        }
        var nextNode = rootNode.content[i + 1];
        var isNextNodeBlock = nextNode && dist_1.isBlock(nextNode);
        var divisor = isNextNodeBlock ? blockDivisor : '';
        return acc + nodeTextValue + divisor;
    }, '');
}

exports.a = documentToPlainTextString;
//# sourceMappingURL=rich-text-plain-text-renderer.es5.js.map


/***/ }),

/***/ 93682:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/why-us",
      function () {
        return __webpack_require__(26124);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Breadcrumbs; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/Common/LinkWrapper/index.jsx + 1 modules
var LinkWrapper = __webpack_require__(40659);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Breadcrumbs/styles.module.scss
var styles_module = __webpack_require__(51701);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/utils/useBreadcrumbs.js



/* harmony default export */ function useBreadcrumbs(param) {
    var className = param.className, _breadcrumbs = param.breadcrumbs, breadcrumbs = _breadcrumbs === void 0 ? [] : _breadcrumbs, dark = param.dark;
    var classNames = classnames_default()((styles_module_default()).breadcrumbs, className, (0,_define_property/* default */.Z)({}, (styles_module_default()).dark, dark));
    return {
        className: classNames,
        breadcrumbs: breadcrumbs
    };
};

;// CONCATENATED MODULE: ./UI/components/Breadcrumbs/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Breadcrumbs = function(props) {
    var ref = useBreadcrumbs(props), breadcrumbs = ref.breadcrumbs, className = ref.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
        "aria-label": "breadcrumbs",
        className: className,
        children: breadcrumbs.map(function(param, i) {
            var to = param.to, title = param.title;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50 * i,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, {
                        path: to,
                        className: classnames_default()((styles_module_default()).item, (0,_define_property/* default */.Z)({}, (styles_module_default()).activeItem, i === breadcrumbs.length - 1)),
                        children: title
                    })
                }))
            }, to);
        })
    });
};
Breadcrumbs.propTypes = {
    breadcrumbs: prop_types_default().instanceOf(Array).isRequired,
    className: (prop_types_default()).string,
    dark: (prop_types_default()).bool
};
/* harmony default export */ var components_Breadcrumbs = (Breadcrumbs);


/***/ }),

/***/ 2610:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26033);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96076);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42222);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);











var Animated = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var PageHeader = function(param) {
    var title = param.title, breadcrumbs = param.breadcrumbs, titleStyles = param.titleStyles, breadcrumbsStyles = param.breadcrumbsStyles, breadcrumbsTheme = param.breadcrumbsTheme, updatedAt = param.updatedAt, type = param.type, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(UI_components_Breadcrumbs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                breadcrumbs: breadcrumbs,
                className: breadcrumbsStyles,
                type: type,
                dark: breadcrumbsTheme === "dark"
            }),
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().titleContainer), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, titleStyles, titleStyles), className),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Animated, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .REVEAL_ANIMATION_PROPS */ .kt), {
                    children: [
                        updatedAt && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            className: (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().updatedAt),
                            children: "Last updated: ".concat((0,utils_helper__WEBPACK_IMPORTED_MODULE_9__/* .formatDate */ .p6)(updatedAt))
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                            children: title
                        }),
                        children
                    ]
                }))
            })
        ]
    });
};
PageHeader.defaultProps = {
    title: "",
    breadcrumbs: null,
    titleStyles: "",
    breadcrumbsStyles: ""
};
PageHeader.propTypes = {
    title: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbs: prop_types__WEBPACK_IMPORTED_MODULE_10___default().instanceOf(Array),
    titleStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    breadcrumbsStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().node)
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 40659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_LinkWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./utils/ga.js
var ga = __webpack_require__(48114);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/helpers/index.js
var isAbsoluteUrl = function(path) {
    try {
        var _ = new URL(path);
        return true;
    } catch (e) {
        return false;
    }
};

// EXTERNAL MODULE: ./components/Common/LinkWrapper/styles.module.scss
var styles_module = __webpack_require__(81098);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./components/Common/LinkWrapper/index.jsx










var LinkWrapper = function(param) {
    var path = param.path, className = param.className, children = param.children, googleAnalyticProps = param.googleAnalyticProps, isSocialLink = param.isSocialLink, onClick = param.onClick;
    var isAbsoluteLink = (0,react.useMemo)(function() {
        return isAbsoluteUrl(path);
    }, [
        path
    ]);
    var isLocalLink = !isAbsoluteLink || path.includes(constants/* CUSTOM_DOMAIN */.zq);
    if (!path) {
        return children;
    }
    var target = !isLocalLink ? "_blank" : undefined;
    var rel = isSocialLink || isLocalLink ? undefined : "noopener noreferrer nofollow";
    var href = !isAbsoluteLink && path[0] !== "/" ? "/".concat(path) : path;
    var handleOnClick = function(e) {
        if (!isEmpty_default()(googleAnalyticProps)) {
            var category = googleAnalyticProps.category, action = googleAnalyticProps.action, label = googleAnalyticProps.label, data = googleAnalyticProps.data;
            ga/* default.trackEvent */.Z.trackEvent(category || data, action || data, label || data);
        }
        onClick(e);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        /* TODO: if you need to instantly open pages via links in the navigation,
      you can remove this code to enable link page generation and loading. However, performance will be degraded
      more: https://nextjs.org/docs/api-reference/next/link */ prefetch: false,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
            className: classnames_default()((styles_module_default()).link, className),
            onClick: handleOnClick,
            target: target,
            rel: rel,
            children: children
        })
    });
};
LinkWrapper.defaultProps = {
    path: null,
    className: null,
    googleAnalyticProps: {},
    children: null,
    isSocialLink: false,
    onClick: function() {}
};
LinkWrapper.propTypes = {
    path: (prop_types_default()).string,
    className: (prop_types_default()).string,
    googleAnalyticProps: prop_types_default().instanceOf(Object),
    children: (prop_types_default()).node,
    isSocialLink: (prop_types_default()).bool,
    onClick: (prop_types_default()).func
};
/* harmony default export */ var Common_LinkWrapper = (LinkWrapper);


/***/ }),

/***/ 38067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Common_MetaTags; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./utils/microdata/data.js
var data = __webpack_require__(13107);
// EXTERNAL MODULE: ./utils/microdata/utils.js
var utils = __webpack_require__(20281);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./utils/microdata/deprecatedData.js




var _obj;
// TODO: Replace with actual data ASAP
var deprecatedData = (_obj = {}, (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareDevelopmentPrice.slug */.y2.softwareDevelopmentPrice.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Pricing: Hire a Team for Your Project | Yellow",
    description: "Calculate how much money you will need to build your software.\n    We only bill for the time actually spent on work, so it's easy to manage the budget. No extra fees.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.penetrationTesting.slug */.y2.penetrationTesting.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Penetration testing  | Yellow",
    description: "Use penetration testing to make sure your software solution is safe for your users. " + "Yellow will provide you with penetration testing services.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customMobileApp.slug */.y2.customMobileApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom mobile app development company | Yellow",
    description: "The best talents for Mobile App Development are here. Hire an experienced team to work on your idea.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.iosDevelopmentServices.slug */.y2.iosDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "iOS Mobile App Development Company | Yellow",
    description: "Yellow can provide you with iOS development services. If you want to create an iPhone or " + "iPad app, we are here to help.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.androidDevelopmentServices.slug */.y2.androidDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Custom Android App Development Company | Yellow",
    description: "Yellow is ready to provide you with Android development services to bring your idea to life.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.prototypingServices.slug */.y2.prototypingServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Mobile App Prototyping Services | Yellow",
    description: "Prototyping is an important stage in mobile app development. Complete it with Yellow!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.customWebApp.slug */.y2.customWebApp.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Web Application Development Services | Yellow",
    description: "Our team is ready to provide you with web development services. " + "We are working with websites, PWAs, chatting applications, and landing pages.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.softwareQualityAssuranceServices.slug */.y2.softwareQualityAssuranceServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Software Quality Assurance and Testing Services | Yellow",
    description: "Quality assurance is an important part of software product creation since it ensures that users" + " will receive a convenient and fully-functional solution. If you need QA services, Yellow is ready to provide them!",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crowdfundingPlatform.slug */.y2.crowdfundingPlatform.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Crowdfunding Platform Development Company | Yellow",
    description: "Yellow is ready to provide you with crowdfunding platform development services. " + "High quality, realistic budget estimate, fast speed.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.fintechDevelopment.slug */.y2.fintechDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Fintech Software Development Services | Yellow",
    description: "The fintech industry is booming and doesn't seem to stop. Let's see how your " + "idea can take the slice of pie?",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.designServices.slug */.y2.designServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "UI/UX design services | Yellow",
    description: "Visual content matters, that is where UI/UX design comes into play.Users love good-looking " + "software. Make mobile your app or website captivating with Yellow.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.discoveryPhase.slug */.y2.discoveryPhase.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Project Discovery Phase in Custom Software Development | Yellow",
    description: "Discovery phase of a project is an important part of software development. " + "Learn more about how Yellow runs a discovery phase to benefit your business."
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.eWalletAppDevelopment.slug */.y2.eWalletAppDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "E-Wallet App Development Company | Yellow",
    description: "Mobile e-wallet app development services for any industry and any business scale.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.bankingSoftwareDevelopmentCompany.slug */.y2.bankingSoftwareDevelopmentCompany.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Banking Software Development Company | Yellow",
    description: "We provide companies and organizations big and small with outstanding banking software " + "development. Check out what we can do for you.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.deliveryQualityInYellow.slug */.y2.deliveryQualityInYellow.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "What Makes Yellow a Good Software Development Partner | Yellow",
    description: "Delivery quality standards we follow to build a perfect project for YOU.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.pwaDevelopmentServices.slug */.y2.pwaDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "PWA Development Services | Yellow",
    description: "Yellow is combining web and mobile worlds and creates progressive web " + "apps that function smoothly on all devices.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.paymentGatewayDevelopment.slug */.y2.paymentGatewayDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Payment Software Gateway Development Company | Yellow",
    description: "Yellow is a leading Payment Gateway Development company, providing customized " + "solutions to enhance transaction security and accuracy. Read more about our services now.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.billingSoftwareDevelopment.slug */.y2.billingSoftwareDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Billing Software Development Services Company | Yellow",
    description: "If you want to create brand-new billing software, partner with Yellow and build a top-tier solution.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.crossPlatformDevelopmentServices.slug */.y2.crossPlatformDevelopmentServices.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "Cross-Platform App Development Services | Yellow",
    description: "Your cross-platform application will rock the stage and Yellow is ready to make it happen.",
    image: data/* logoUrl */.pt
}), (0,_define_property/* default */.Z)(_obj, constants/* ROUTES.devOpsDevelopment.slug */.y2.devOpsDevelopment.slug, {
    "@context": utils/* context */.Do,
    "@type": "WebPage",
    name: "DevOps Development Company | Yellow",
    description: "If your company wants to integrate DevOps service into its processes and get all " + "the benefits this technology offers, Yellow is ready to lend a hand!",
    image: data/* logoUrl */.pt
}), _obj);

;// CONCATENATED MODULE: ./utils/microdata/index.js






function getPageMicrodata(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, breadcrumbs = ref.breadcrumbs, microData = ref.microData;
    var microdataArray = [
        // TODO: uncomment when deprecated data will be replaced
        // webpageMicrodata,
        data/* websiteMicrodata */.IR,
        data/* organisationMicrodata */.nW, 
    ];
    var breadcrumbsMicrodata = (0,utils/* getBreadcrumbsMicrodata */.js)(breadcrumbs);
    if (breadcrumbsMicrodata) {
        microdataArray.push(breadcrumbsMicrodata);
    }
    switch(page){
        case constants/* ROUTES.homepage.slug */.y2.homepage.slug:
        case constants/* ROUTES.contact.slug */.y2.contact.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            break;
        case constants/* ROUTES.company.slug */.y2.company.slug:
        case constants/* ROUTES.whyUs.slug */.y2.whyUs.slug:
            microdataArray.push(data/* localBusinessMicrodata */._c);
            microdataArray.push(data/* professionalServiceMicrodata */.jh);
            microdataArray.push(data/* aboutPageMicrodata */.WN);
            break;
        case constants/* ROUTES.blog.slug */.y2.blog.slug:
        case constants/* ROUTES.portfolio.slug */.y2.portfolio.slug:
        case constants/* ROUTES.project.slug */.y2.project.slug:
        case constants/* ROUTES.process.slug */.y2.process.slug:
        case constants/* ROUTES.termsAndConditions.slug */.y2.termsAndConditions.slug:
        case constants/* ROUTES.cookiesPolicy.slug */.y2.cookiesPolicy.slug:
        case constants/* ROUTES.privacyPolicy.slug */.y2.privacyPolicy.slug:
            break;
        case constants/* ROUTES.article.slug */.y2.article.slug:
            microdataArray.push((0,utils/* getArticleMicrodata */.WK)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, microData), {
                organisationMicrodata: data/* organisationMicrodata */.nW
            })));
            break;
        case constants/* ROUTES.person.slug */.y2.person.slug:
            microdataArray.push((0,utils/* getPersonMicrodata */.RK)(microData));
            break;
        default:
            var currentRoute = Object.values(constants/* ROUTES */.y2).find(function(route) {
                return route.slug === page;
            });
            var oldData = deprecatedData[page];
            if (oldData) {
                microdataArray.push(oldData);
                break;
            }
            microdataArray.push((0,utils/* getServiceMicrodata */.fi)(currentRoute, {
                organisationMicrodata: data/* organisationMicrodata */.nW,
                category: data/* CATEGORY */.En[page],
                offers: data/* OFFERS */.jn[page],
                addresses: data/* addresses */.UB
            }));
            break;
    }
    return microdataArray;
}

;// CONCATENATED MODULE: ./components/Common/MetaTags/utils/data.js
var defaultMetadata = {
    title: "Trusted AI Transformation Agency | Yellow",
    description: "We help businesses turn their AI initiatives into production-grade solutions with measurable results."
};

;// CONCATENATED MODULE: ./components/Common/MetaTags/index.jsx
/* eslint-disable react/jsx-max-props-per-line */ 






var MetaTags = function(param) {
    var page = param.page, pageMetadata = param.pageMetadata, children = param.children, breadcrumbs = param.breadcrumbs, microData = param.microData, isArticle = param.isArticle;
    var metaTitle = pageMetadata.metaTitle, metaDescription = pageMetadata.metaDescription, metaRobots = pageMetadata.metaRobots, image = pageMetadata.image, publishedAt = pageMetadata.publishedAt, categoryTag = pageMetadata.categoryTag, keyWords = pageMetadata.keyWords, pageNumber = pageMetadata.pageNumber, url = pageMetadata.url, ogImage = pageMetadata.ogImage;
    var microdata = getPageMicrodata(page, {
        breadcrumbs: breadcrumbs,
        microData: microData
    });
    var getTitle = function() {
        return pageNumber > 1 ? "".concat(metaTitle || defaultMetadata.title, " | Page ").concat(pageNumber) : metaTitle || defaultMetadata.title;
    };
    var getDescription = function() {
        return pageNumber > 1 ? "".concat(metaDescription || defaultMetadata.description, " | Page ").concat(pageNumber) : metaDescription || defaultMetadata.description;
    };
    var getImage = function() {
        if (ogImage) return ogImage;
        if (isArticle) return image;
        return (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png");
    };
    var date = isArticle ? publishedAt : new Date();
    var type = isArticle ? "article" : "website";
    var title = getTitle();
    var description = getDescription();
    var robots = !constants/* IS_PROD */.XK ? "none" : metaRobots;
    return(// eslint-disable-next-line @next/next/no-script-component-in-head
    /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "date",
                content: date
            }),
            robots && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "robots",
                content: robots
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "canonical",
                href: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:locale",
                content: "en_US"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: getImage()
            }),
            categoryTag && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:section",
                content: categoryTag
            }),
            publishedAt && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "article:published_time",
                content: publishedAt
            }),
            keyWords === null || keyWords === void 0 ? void 0 : keyWords.map(function(keyWord) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                    property: "article:tag",
                    content: keyWord
                }, "meta/tag/".concat(keyWord));
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "initial-scale=1.0, width=device-width"
            }, "viewport"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "shortcut icon",
                href: (0,helper/* getPathWithCdn */.d6)("/yellow_logo.ico")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: (0,helper/* getPathWithCdn */.d6)("/apple-touch-icon.png")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "mask-icon",
                href: (0,helper/* getPathWithCdn */.d6)("/safari-pinned-tab.svg"),
                color: "#ffbf02"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "manifest",
                href: "/manifest.json"
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "application/ld+json/microdata",
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(microdata, null, 2)
                }
            })
        ]
    }));
};
MetaTags.defaultProps = {
    children: null,
    pageMetadata: {},
    articleData: {},
    breadcrumbs: [],
    isArticle: false
};
MetaTags.propTypes = {
    page: (prop_types_default()).string.isRequired,
    breadcrumbs: prop_types_default().instanceOf(Array),
    articleData: prop_types_default().instanceOf(Object),
    pageMetadata: prop_types_default().shape({
        metaTitle: (prop_types_default()).string,
        metaDescription: (prop_types_default()).string,
        metaRobots: (prop_types_default()).string,
        image: (prop_types_default()).string,
        ogImage: (prop_types_default()).string,
        publishedAt: (prop_types_default()).string,
        categoryTag: (prop_types_default()).string,
        keyWords: prop_types_default().instanceOf(Array),
        pageNumber: (prop_types_default()).number
    }),
    children: prop_types_default().oneOfType([
        (prop_types_default()).string,
        (prop_types_default()).array,
        (prop_types_default()).element, 
    ]),
    isArticle: (prop_types_default()).bool,
    defaultMetaData: prop_types_default().instanceOf(Array)
};
/* harmony default export */ var Common_MetaTags = (MetaTags);


/***/ }),

/***/ 26124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ why_us; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/PageHeader/index.jsx
var PageHeader = __webpack_require__(2610);
// EXTERNAL MODULE: ./components/Common/MetaTags/index.jsx + 3 modules
var MetaTags = __webpack_require__(38067);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./redux/apis/page.js
var page = __webpack_require__(85144);
// EXTERNAL MODULE: ./utils/breadcrumbs.js
var utils_breadcrumbs = __webpack_require__(84047);
// EXTERNAL MODULE: ./UI/views/WhyUs/styles.module.scss
var styles_module = __webpack_require__(57447);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/views/WhyUs/index.jsx











var WhyUsCommon = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 52761).then(__webpack_require__.bind(__webpack_require__, 52761)).then(function(module) {
        return module.WhyUsCommon;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52761)
            ];
        }
    }
});
var WhyUs = function(param) {
    var metaData = param.metaData, type = param.type, introSection = param.introSection, ssrContentModules = param.contentModules;
    var ref = (0,page/* useFetchPageQuery */.oO)(type, {
        skip: Boolean(ssrContentModules)
    }), _data = ref.data, data = _data === void 0 ? {} : _data;
    var contentModules = ssrContentModules !== null && ssrContentModules !== void 0 ? ssrContentModules : data.contentModules;
    var breadcrumbs = (0,utils_breadcrumbs/* getBreadcrumbs */.Z)(type);
    var pageMetadata = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, metaData), {
        url: "".concat(helper/* rootUrl */.Wd, "/").concat(type)
    });
    if (!contentModules) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                page: constants/* PAGES.whyUs */.q5.whyUs,
                pageMetadata: pageMetadata,
                breadcrumbs: breadcrumbs
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                className: (styles_module_default()).container,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                        breadcrumbsTheme: "light",
                        breadcrumbsStyles: (styles_module_default()).breadcrumbs,
                        titleStyles: (styles_module_default()).titleStyles,
                        breadcrumbs: breadcrumbs
                    }),
                    contentModules === null || contentModules === void 0 ? void 0 : contentModules.map(function(section) {
                        var ref = (0,helper/* getDocumentFields */.OA)(section, [
                            "type",
                            "view",
                            "slug"
                        ]), sectionType = ref.type, view = ref.view, slug = ref.slug;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyUsCommon, {
                            type: type,
                            section: section,
                            introSection: introSection
                        }, "".concat(type, "/").concat(sectionType, "-").concat(view || slug));
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var views_WhyUs = (WhyUs);

;// CONCATENATED MODULE: ./pages/why-us.js




var why_us_WhyUs = function(_param) /*#__PURE__*/ {
    var introSection = _param.introSection, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "introSection"
    ]);
    return (0,jsx_runtime.jsx)(views_WhyUs, (0,_object_spread/* default */.Z)({
        introSection: introSection
    }, rest));
};
var __N_SSG = true;
/* harmony default export */ var why_us = (why_us_WhyUs);


/***/ }),

/***/ 85144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "oO": function() { return /* binding */ useFetchPageQuery; }
/* harmony export */ });
/* unused harmony exports useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(29815);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97582);
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6572);
/* harmony import */ var utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(24376);
/* harmony import */ var utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(65686);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96076);
/* harmony import */ var utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91217);
/* harmony import */ var utils_error__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(93250);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91555);












var pageApi = ___WEBPACK_IMPORTED_MODULE_0__["default"].injectEndpoints({
    endpoints: function(builder) {
        return {
            fetchPage: builder.query({
                queryFn: function queryFn(value) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var client, ref, ref1, response, data, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: {}
                                            }
                                        ];
                                    }
                                    client = utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_FALLBACK_CONTENTFUL.includes */ .Bt.includes(value) ? utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient : utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.contentfulClient;
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        client.getEntries({
                                            contentType: "page",
                                            additionalQueryParams: {
                                                "fields.slug": value
                                            }
                                        })
                                    ];
                                case 2:
                                    response = _state.sent();
                                    data = (response === null || response === void 0 ? void 0 : (ref = response.items) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.fields) || {};
                                    return [
                                        2,
                                        {
                                            data: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data), {
                                                metaData: {
                                                    metaTitle: data.metaTitle || "",
                                                    metaDescription: data.metaDescription || "",
                                                    metaRobots: data.metaRobots || "",
                                                    ogImage: (0,utils_helper__WEBPACK_IMPORTED_MODULE_7__/* .getFileUrl */ .qm)(data.ogImage)
                                                }
                                            })
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResult: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            }),
            getPageSearchResultFallback: builder.query({
                extraOptions: {
                    type: ___WEBPACK_IMPORTED_MODULE_0__.BASEQUERY_TYPES.graphql,
                    client: utils_contentful_client__WEBPACK_IMPORTED_MODULE_4__.fallbackClient
                },
                queryFn: function queryFn(value, _, __, baseQuery) {
                    return (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function() {
                        var byText, result, e;
                        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!value) {
                                        return [
                                            2,
                                            {
                                                data: []
                                            }
                                        ];
                                    }
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        baseQuery(utils_contentful_graphqlQuery__WEBPACK_IMPORTED_MODULE_9__/* .GRAPHQL_QUERY.loadPreviewPages */ .f.loadPreviewPages({
                                            limit: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .SEARCH_ARTICLES_LIMIT */ .WV,
                                            where: {
                                                pageTitle_contains: value,
                                                slug_not_in: utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .PAGES_EXCLUDE_SEARCH */ .fb
                                            }
                                        }))
                                    ];
                                case 2:
                                    byText = _state.sent();
                                    result = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,utils_contentful_helper__WEBPACK_IMPORTED_MODULE_11__/* .getGraphqlResultPages */ .ke)(byText.data));
                                    return [
                                        2,
                                        {
                                            data: result
                                        }
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,utils_error__WEBPACK_IMPORTED_MODULE_8__/* .handleError */ .S3)(e);
                                    return [
                                        2,
                                        {
                                            error: e.message
                                        }
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })();
                }
            })
        };
    }
});
var useFetchPageQuery = pageApi.useFetchPageQuery, useGetPageSearchResultQuery = pageApi.useGetPageSearchResultQuery, useGetPageSearchResultFallbackQuery = pageApi.useGetPageSearchResultFallbackQuery;
/* harmony default export */ __webpack_exports__["ZP"] = (pageApi);


/***/ }),

/***/ 84047:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getBreadcrumbs; }
/* harmony export */ });
/* harmony import */ var utils_helper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6572);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96076);


function getBreadcrumbs(page) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, title = ref.title, slug = ref.slug, tagsList = ref.tagsList;
    var currentRoute = Object.values(utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES */ .y2).find(function(route) {
        return route.slug === page;
    });
    var breadcrumbs = [
        {
            to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.path */ .y2.homepage.path,
            title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.homepage.title */ .y2.homepage.title
        }, 
    ];
    switch(currentRoute.slug){
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.slug */ .y2.blog.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (slug && !(0,utils_helper__WEBPACK_IMPORTED_MODULE_1__/* .isNumeric */ .kE)(slug)) {
                var tag = tagsList === null || tagsList === void 0 ? void 0 : tagsList.find(function(param) {
                    var tagSlug = param.slug;
                    return tagSlug === slug;
                });
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.getRoute */ .y2.blog.getRoute(slug).path,
                    title: tag === null || tag === void 0 ? void 0 : tag.title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.slug */ .y2.project.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.path */ .y2.portfolio.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.portfolio.breadcrumpsTitle */ .y2.portfolio.breadcrumpsTitle
            });
            if (title && slug) {
                var cleanTitle = (title === null || title === void 0 ? void 0 : title.replace(/\s*\[Case Study\].*$/, "").trim()) || "";
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.project.getRoute */ .y2.project.getRoute(slug).path,
                    title: cleanTitle
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.slug */ .y2.article.slug:
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.article.getRoute */ .y2.article.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        case utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.slug */ .y2.person.slug:
            breadcrumbs.splice(0, 1);
            breadcrumbs.push({
                to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.path */ .y2.blog.path,
                title: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.blog.title */ .y2.blog.title
            });
            if (title && slug) {
                breadcrumbs.push({
                    to: utils_constants__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.person.getRoute */ .y2.person.getRoute(slug).path,
                    title: title
                });
            }
            return breadcrumbs;
        default:
            breadcrumbs.push({
                to: currentRoute.path,
                title: currentRoute.title
            });
            return breadcrumbs;
    }
}


/***/ }),

/***/ 51701:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"styles_breadcrumbs__U7jAD","item":"styles_item__WAV19","activeItem":"styles_activeItem__Sdvlz","dark":"styles_dark__9MzT_"};

/***/ }),

/***/ 42222:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"styles_titleContainer__EQ1kE","updatedAt":"styles_updatedAt__pww8i"};

/***/ }),

/***/ 57447:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__BwQmk","pageTitle":"styles_pageTitle__2w9p8","breadcrumbs":"styles_breadcrumbs__o6h4A"};

/***/ }),

/***/ 81098:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"link":"styles_link__MXUD5"};

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [24168,57330,13107,49774,92888,40179], function() { return __webpack_exec__(93682); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);